const PATH_CACHES_KEYS = {
  CAMPAIGN_INDEX: "CAMPAIGN_INDEX"
}

const STORE = {
  PATH_CACHES_KEYS
}

export default STORE
